import { SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  size?: number
}

export const NavDiscordIcon = ({ size = 24, ...props }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.6806 17.2016C14.4218 17.2637 14.1614 17.3187 13.8996 17.3666C12.4788 17.6298 11.02 17.6243 9.60121 17.3508C9.35272 17.3032 9.00099 17.2191 8.54759 17.1L7.06156 19C3.39407 18.8841 2 16.4666 2 16.4666C2 11.1001 4.38959 6.74932 4.38959 6.74932C6.77919 4.95093 9.05262 5.00013 9.05262 5.00013L9.70286 5.83346C9.76278 5.8252 9.8231 5.8199 9.88357 5.81759C11.1231 5.65596 12.3792 5.6613 13.6172 5.83346L14.3303 5.00013C14.3303 5.00013 16.6054 4.95093 18.9934 6.75091C18.9934 6.75091 21.3846 11.1001 21.3846 16.4666C21.3846 16.4666 19.9728 18.8825 16.3053 19L14.6806 17.2V17.2016ZM8.48789 11.5192C7.51817 11.5192 6.75176 12.2334 6.75176 13.1064C6.75176 13.9794 7.53431 14.6937 8.48789 14.6937C9.45599 14.6937 10.2224 13.9794 10.2224 13.1064C10.2385 12.2334 9.4576 11.5192 8.48789 11.5192ZM14.6966 11.5192C13.7286 11.5192 12.9621 12.2334 12.9621 13.1064C12.9621 13.9794 13.7447 14.6937 14.6966 14.6937C15.6664 14.6937 16.4328 13.9794 16.4328 13.1064C16.4328 12.2334 15.6664 11.5192 14.6966 11.5192Z"
        fill="white"
      />
    </svg>
  )
}
